<mat-form-field id="language-selector">
  <mat-label>{{ "LANGUAGE_SELECTOR.LANGUAGE" | translate }}</mat-label>
  <mat-select
    [formControl]="languageSelector"
    (selectionChange)="setLanguage($event.value)"
  >
    <mat-option *ngFor="let language of languages" [value]="language">
      {{ language }}
    </mat-option>
  </mat-select>
</mat-form-field>
